import { fn } from '@ember/helper';
import { get } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import can from 'ember-can/helpers/can';

import Button from 'umg-ember-backend/components/ui/button';
import ContextMenu from 'umg-ember-backend/components/ui/context-menu';
import { getRecordType } from 'umg-ember-backend/utils/get-record-type';
import { lookupTranslation } from 'umg-ember-backend/utils/intl';

export default class RecordExplorerTableTdRowActions extends Component {
  // Services
  @service intl;

  // Defaults
  permissionMap = {
    delete: 'delete',
    duplicate: 'create',
    edit: 'read',
    lockOrUnlockUser: 'update',
  };

  // Functions
  getIcon = (key, record) => {
    const iconMap = {
      delete: 'delete',
      duplicate: 'duplicate',
      edit: 'edit',
    };

    if (key === 'lockOrUnlockUser') {
      return record.status === 2 ? 'lock' : 'unlock';
    }

    return iconMap[key];
  };

  getIconClass = (key) => {
    const iconClassMap = {
      delete: 'u-color-error',
    };

    return iconClassMap[key];
  };

  getLabel = (key, record) => {
    let action = key;
    if (key === 'lockOrUnlockUser') {
      action = record.status === 2 ? 'lock_user' : 'unlock_user';
    }

    const lookups = [
      `record_explorer.table.td.row_actions.${getRecordType(record)}.${action}`,
      `record_explorer.table.td.row_actions.default.${action}`,
    ];

    const recordTypeLabel = this.intl.t(`models.${getRecordType(record)}`);
    return lookupTranslation.call(this, lookups, {
      intlOptions: {
        recordTypeLabel: recordTypeLabel,
      },
    });
  };

  // Template
  <template>
    {{#if @recordActions}}
      <ContextMenu @isDisabled={{@row.isSaving}} @renderInPlace={{false}}>
        <:trigger>
          <Button @icon='more' @style='primary' disabled={{@isDisabled}} />
        </:trigger>

        <:content as |content|>
          {{#each-in @recordActions as |key recordAction|}}
            {{#if (can (get this.permissionMap key) @record)}}
              <content.Item
                @icon={{this.getIcon key @record}}
                @iconClass={{this.getIconClass key}}
                @onClick={{fn recordAction @record}}
                @label={{this.getLabel key @record}}
              />
            {{/if}}
          {{/each-in}}
        </:content>
      </ContextMenu>
    {{/if}}
  </template>
}
